import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Link } from '@zola/zola-ui';

import UploadButton from '../upload/UploadButton';
import { hideModal } from '../../../actions/modalActions';
import { inputBtnTempUpload } from '../../../actions/fileActions';

function RejectSmallPhotoUploadModal(props) {
  const { w, h, minW, minH, onPhotoSelect } = props;
  return (
    <div>
      <div className="modal-header">
        <h2 className="modal-title">This Photo Is Too Small</h2>
      </div>
      <div className="modal-body">
        <div className="reject-photo-container">
          <p>
            The photo you have uploaded is <strong>{`${w} pixels by ${h} pixels`}</strong>
          </p>
          <p>
            We recommend uploading a file that is at least{' '}
            <strong>
              {minW || '1200'} pixels by {minH || '1200'} pixels
            </strong>{' '}
            in size to ensure that your photo prints clearly.
          </p>
          <p>
            For more on uploading photos, check out our{' '}
            <Link
              inline
              href="https://help.zola.com/hc/en-us/articles/360012943071-What-kinds-of-photos-can-I-upload-on-my-card"
            >
              FAQs.
            </Link>
          </p>
        </div>
      </div>
      <div className="modal-footer">
        <UploadButton
          skinBtn={<React.Fragment>Change Photo</React.Fragment>}
          onPhotoSelect={file => onPhotoSelect(file, minW, minH)}
        />
      </div>
    </div>
  );
}

RejectSmallPhotoUploadModal.propTypes = {
  w: PropTypes.number,
  h: PropTypes.number,
  minW: PropTypes.number,
  minH: PropTypes.number,
  onPhotoSelect: PropTypes.func,
};

const connectDispatchToProps = (dispatch, ownProps) => ({
  onSubmit: () => {
    dispatch(hideModal());
    if (ownProps.callback) ownProps.callback();
  },
  onCancel: () => dispatch(hideModal()),
  onPhotoSelect: (file, width, height) =>
    dispatch(inputBtnTempUpload(file, 'new_photo', width, height)),
});

export default connect(null, connectDispatchToProps)(RejectSmallPhotoUploadModal);



// WEBPACK FOOTER //
// ./src/cards/components/common/modals/RejectSmallPhotoUploadModal.jsx